export default {
  cancelReasonLabel: 'Raison de l\'annulation',
  cancelCommentLabel: 'Commentaire',
  cancel: 'Annuler'
};
